import type { Topic } from '../../../backend/main';
import { FormControl, Validators } from '@angular/forms';
import { createPctFormGroup } from '../form-controls/create-pct-form-group';
import type { CategoryDetailsFormValues } from './category-details-form';
import { CategoryDetailsForm } from './category-details-form';
import type { PctFormGroup } from '@pct/ng-form';

export interface CategoryDetailsFormValuesWithTopics extends CategoryDetailsFormValues {
  topics: Topic[];
}

export class CategoryDetailsFormWithTopics extends CategoryDetailsForm {
  override readonly topicsControl = new FormControl<Topic[]>([], {
    nonNullable: true,
    validators: [Validators.required],
  });

  protected override readonly builtFormGroup = createPctFormGroup({
    status: this.statusControl,
    translations: this.translationsFormArray,
    topics: this.topicsControl,
  }) as PctFormGroup;

  override formGroup(): PctFormGroup {
    return this.builtFormGroup;
  }
}
